import { atom } from 'recoil';
import { PaymentType } from '~/types/common';

const paymentType = atom<PaymentType>({
  key: 'paymentType',
  default: PaymentType.NONE,
});

export default paymentType;
